import Text from 'ui/Text/Text';
import Title from 'ui/Title/Title';
import './Integrations.scss';
import Wave from './Wave/Wave';

const Integrations = ({ isActive }) => {
  return (
    <div className="integrations section" id="integrations">
      <div className="container integrations__container">
        <div className="integrations__content">
          <Title className="integrations__title">Integrations</Title>
          <Text className="integrations__text">
            Samudai organizes information and provides tools to enable seamless
            coordination across the DAO ecosystem
          </Text>
        </div>
        <div className="integrations_wavetext">
          {/* <Wave isActive={isActive}>
            LOS ANGELES WIRE coinweek New York Weekly LOS ANGELES WIRE coinweek New York Weekly LOS ANGELES WIRE coinweek New York Weekly LOS ANGELES WIRE coinweek New York Weekly LOS ANGELES WIRE coinweek New York Weekly LOS ANGELES WIRE coinweek New York Weekly
          </Wave> */}
        </div>
      </div>
    </div>
  );
};

export default Integrations;
